import { render, staticRenderFns } from "./edit-banner.vue?vue&type=template&id=a270b334&scoped=true&"
import script from "./edit-banner.vue?vue&type=script&lang=js&"
export * from "./edit-banner.vue?vue&type=script&lang=js&"
import style0 from "./edit-banner.vue?vue&type=style&index=0&id=a270b334&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a270b334",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
